export default __webpack_public_path__ + "static/media/ovo-logo.77f07acf.svg";